import React from "react";

/**
 * FormActions renders cancel and submit buttons for forms.
 *
 * Props:
 *  - isLoading?: boolean
 *  - onCancel: () => void
 *  - submitLabel: string
 *  - cancelLabel?: string
 */
export function FormActions({
  isLoading = false,
  onCancel,
  submitLabel,
  cancelLabel,
}) {
  return (
    <div className="flex justify-end gap-3 pt-6 border-t border-gray-200">
      <button
        type="button"
        className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        onClick={onCancel}
        disabled={isLoading}
      >
        {cancelLabel}
      </button>
      <button 
        type="submit" 
        className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        disabled={isLoading}
      >
        {isLoading ? `${submitLabel}…` : submitLabel}
      </button>
    </div>
  );
}